export default {
    "Records": "Enregistrements",
    "No records": "Aucun enregistrement",
    "Delete all records": "Supprimer tous les enregistrements",
    "Preview": "Aperçu",
    "Download": "Télécharger",
    "Delete": "Supprimer",
    "Video trimming function": "Fonction de découpage vidéo",
    "Move the playhead to the points in time you want to trim the video, or select the In and Out timecodes.": "Déplacez la tête de lecture aux points dans le temps où vous souhaitez découper la vidéo, ou sélectionnez les codes temporels de début et de fin.",
    "Timecode IN": "Code temporel DÉBUT",
    "Cut IN from current timecode": "Couper DÉBUT depuis le timecode actuel",
    "Timecode OUT": "Code temporel FIN",
    "Cut OUT from current timecode": "Couper FIN depuis le timecode actuel",
    "New record name": "Nom du nouvel enregistrement",
    "Trim the file": "Découper le fichier",
    "audience": "audience",
    "Current viewers": "Spectateurs actuels",
    "The number of viewers currently watching your player": "Le nombre de spectateurs regardant actuellement votre lecteur",
    "Max viewers": "Spectateurs max",
    "How many simultaneous viewers are allowed on your player": "Combien de spectateurs simultanés sont autorisés sur votre lecteur",
    "Total views": "Vues totales",
    "The number of times your player has been watched": "Le nombre de fois que votre lecteur a été regardé",
    "Viewers graph": "Graphique des spectateurs",
    "Number of viewers per period of time": "Nombre de spectateurs par période de temps",
    "af": "Afrikaans",
    "sq": "Albanais",
    "am": "Amharique",
    "ar": "Arabe",
    "hy": "Arménien",
    "as": "Assamais",
    "az": "Azéri",
    "ba": "Bachkir",
    "eu": "Basque",
    "be": "Biélorusse",
    "bn": "Bengali",
    "bs": "Bosniaque",
    "br": "Breton",
    "bg": "Bulgare",
    "ca": "Catalan",
    "zh": "Chinois",
    "hr": "Croate",
    "cs": "Tchèque",
    "da": "Danois",
    "nl": "Néerlandais",
    "en": "Anglais",
    "et": "Estonien",
    "fo": "Féroïen",
    "fi": "Finnois",
    "fr": "Français",
    "gl": "Galicien",
    "ka": "Géorgien",
    "de": "Allemand",
    "el": "Grec",
    "gu": "Gujarati",
    "ht": "Créole haïtien",
    "ha": "Haoussa",
    "haw": "Hawaïen",
    "he": "Hébreu",
    "hi": "Hindi",
    "hu": "Hongrois",
    "is": "Islandais",
    "id": "Indonésien",
    "it": "Italien",
    "ja": "Japonais",
    "jw": "Javanais",
    "kn": "Kannada",
    "kk": "Kazakh",
    "km": "Khmer",
    "ko": "Coréen",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Letton",
    "ln": "Lingala",
    "lt": "Lituanien",
    "lb": "Luxembourgeois",
    "mk": "Macédonien",
    "mg": "Malgache",
    "ms": "Malais",
    "ml": "Malayalam",
    "mt": "Maltais",
    "mi": "Maori",
    "mr": "Marathi",
    "mn": "Mongol",
    "my": "Birman",
    "ne": "Népalais",
    "no": "Norvégien",
    "nn": "Nynorsk",
    "oc": "Occitan",
    "ps": "Pashto",
    "fa": "Persan",
    "pl": "Polonais",
    "pt": "Portugais",
    "pa": "Pendjabi",
    "ro": "Roumain",
    "ru": "Russe",
    "sa": "Sanskrit",
    "sr": "Serbe",
    "sn": "Shona",
    "sd": "Sindhi",
    "si": "Cingalais",
    "sk": "Slovaque",
    "sl": "Slovène",
    "so": "Somali",
    "es": "Espagnol",
    "su": "Soudanais",
    "sw": "Swahili",
    "sv": "Suédois",
    "tl": "Tagalog",
    "tg": "Tadjik",
    "ta": "Tamoul",
    "tt": "Tatar",
    "te": "Télougou",
    "th": "Thaï",
    "bo": "Tibétain",
    "tr": "Turc",
    "tk": "Turkmène",
    "uk": "Ukrainien",
    "ur": "Ourdou",
    "uz": "Ouzbek",
    "vi": "Vietnamien",
    "cy": "Gallois",
    "wo": "Wolof",
    "yi": "Yiddish",
    "yo": "Yoruba"
}